export const TEXTAREA_CHARACTER_LIMIT = 60

export const QUANTITY_INPUT = 'QUANTITY_INPUT'
